import * as yup from "yup";
import { useForm, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";

const initialState = {
	popularItemSettings: {
		enabled: false,
		automationCreate: false,
	} 
}

export const popularItemSettingsSchema = yup.object().shape({
	popularItemSettings: yup.object().shape({
		enabled: yup.boolean(),
		automationCreate: yup.boolean(),
	}),
});

const usePopularItemSettings = (popularItemSettingsData) => {
	
	const popularItemSettings = useForm({
		defaultValues: initialState,
		resolver: yupResolver(popularItemSettingsSchema),
		mode: 'all',
	});

 const enabledWatcher = useWatch({
		control: popularItemSettings.control,
		name: "popularItemSettings.enabled",
  });

	const handleSubmit = () => {};

	useEffect(() => {
		popularItemSettings.setValue(
		  'popularItemSettings.automationCreate',
			popularItemSettingsData?.automationCreate ?? false
		);
	}, [enabledWatcher]);

	useEffect(() => {
		if (popularItemSettingsData && 
			popularItemSettingsData?.hasOwnProperty('enabled') && 
			popularItemSettingsData?.hasOwnProperty('automationCreate')) {
				popularItemSettings.reset({
					popularItemSettings: {
						enabled: popularItemSettingsData.enabled,
						automationCreate: popularItemSettingsData.automationCreate,
					}
				}, { keepDirty: true });
			} else {
				popularItemSettings.reset({	
					popularItemSettings: {
						enabled: false,
						automationCreate: false,
					}
				}, { keepDirty: false });
		}
	}, [popularItemSettingsData]);

  return {
    popularItemSettings,
    handleSubmit,
	};
};

export default usePopularItemSettings;
